module.exports = __webpack_public_path__ + "openhand.b06c243f534d9c5461d1.cur";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/revolution/css/openhand.cur
// module id = ../../../../../src/assets/revolution/css/openhand.cur
// module chunks = styles